export default "__VITE_ASSET__c22d5e6a__"